import { render, staticRenderFns } from "./pagesHeader.vue?vue&type=template&id=a1eae07a&scoped=true"
import script from "./pagesHeader.vue?vue&type=script&lang=js"
export * from "./pagesHeader.vue?vue&type=script&lang=js"
import style0 from "./pagesHeader.vue?vue&type=style&index=0&id=a1eae07a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1eae07a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonfy/Documents/项目/精打硒算/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1eae07a')) {
      api.createRecord('a1eae07a', component.options)
    } else {
      api.reload('a1eae07a', component.options)
    }
    module.hot.accept("./pagesHeader.vue?vue&type=template&id=a1eae07a&scoped=true", function () {
      api.rerender('a1eae07a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/pagesHeader.vue"
export default component.exports